import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export function useGooglePayAvailability() {
  const googlePayEnabled = useFlag('enable-google-pay');

  //  TODO: test on actual safari browser to eliminate isSafari check
  /*
   * feat(FHS-2933): Disabling google pay on safari (#1725)
   * ### Summary
   * Currently google pay is not working at all on safari's browser. This PR
   * is to disable it on that case so we can avoid user's use it on safari
   * until we find a better solution with it.
   * https://github.com/rbilabs/fhs-app/issues/1725
   */
  const canUseGooglePay = isSafari() ? false : googlePayEnabled;

  return canUseGooglePay;
}

function isSafari(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  // needs check for not .includes chrome because chrome's user agent also has safari
  return userAgent.includes('safari') && !userAgent.includes('chrome');
}
